// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-4ONcT","rotate":"rotate-SWQO-","loadingSmall":"loadingSmall-dx6b4","loadingMedium":"loadingMedium-zl43M","loadingBig":"loadingBig-basFJ"};